const comMain = () => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    const secMain = document.querySelector('#jsComSecMain');
    const bgWrap = secMain.querySelector('.js-bg-wrap');
    const bgBox = bgWrap.querySelector('.js-bg-box');
    const mainWrap = secMain.querySelector('.js-main-wrap');
    const copyBox = mainWrap.querySelector('.js-copy-box');


    let elem = bgBox.querySelector('.js-effect')

    let intensity
    let image
    let displacement
    let imagesRatioX
    let imagesRatioY

    if (document.querySelector("body#pageAboutus") !== null) {
      intensity = 0.2
      image = '../assets/build/img/about-us/main_bg.jpg'
      displacement = '../assets/lib/hover-effect/displacement/clouds.jpg'
      imagesRatioX = 2880
      imagesRatioY = 1604
    }

    if (document.querySelector("body#pageRenewableenergy") !== null) {
      intensity = 0.2
      image = '../assets/build/img/renewable-energy/main_bg.jpg'
      displacement = '../assets/lib/hover-effect/displacement/10.jpg'
      imagesRatioX = 2880
      imagesRatioY = 3600
    }

    if (document.querySelector("body#pageOutline") !== null) {
      intensity = 0.1
      image = '../assets/build/img/outline/main_bg.jpg'
      displacement = '../assets/lib/hover-effect/displacement/6.jpg'
      imagesRatioX = 2880
      imagesRatioY = 1920
    }

    let animation = new hoverEffect({
      parent: elem,
      intensity: intensity,
      image1: image,
      image2: image,
      displacementImage: displacement,
      speedIn: 1.6 * 1.6,
      speedOut: 1.2 * 1.6,
      hover: false,
      imagesRatio: imagesRatioY / imagesRatioX,
    });

    setTimeout(() => {
      bgBox.classList.add('is-act')
      animation.next()
      setTimeout(() => {
        copyBox.classList.add('is-act')
      }, 1200);
    }, 400);



    const fadeElem = document.querySelectorAll('.js-com-main-end');
    if (fadeElem.length > 0) {

      gsap.set(".js-com-main-end", {
        autoAlpha: 0,
      });

      gsap.to(".js-com-main-end", {
        autoAlpha: 1,
        duration: 2,
        delay: 3.0,
        ease: "power1.out",
      });

    }



  }
}
export default comMain;